// function FetchFromURL( url, cb )
// {
//     var xhr = new XMLHttpRequest( );   
    
//     xhr.onreadystatechange = function( )
//     {
//         if ( xhr.readyState == 4 )
//         {
//             cb( xhr, xhr.responseText );
//         }
//     }; 

//     xhr.open( "GET", url, true );
//     xhr.send( );
// }
function FetchFromURL(url, cb) {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = false; // important: equivalent to credentials:'omit'

    // cache-buster only (no custom headers)
    const bust = (url.includes('?') ? '&' : '?') + '_=' + Date.now();
    xhr.open('GET', url + bust, true);

    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) cb(xhr, xhr.responseText);
    };

    xhr.send();
}

function LoadSymptomToolReactApp( )
{
    var scriptTag = document.getElementById( "app-main" );
    var srcURL    = scriptTag.getAttribute( "data-src" );
    var gtm_id_codebase = 'GTMID';

    FetchFromURL( srcURL, function( xhr, data )
    {
        results_url = window.results_url ? window.results_url : 'symptom-tool-results';
        // data = data.replaceAll( "/${e}/symptom-tool/results", "/${e}/pages/"+results_url );
        // data = data.replaceAll( "/symptom-tool/results", "/pages/"+results_url );
        // data = data.replaceAll( "/${e.userId}", "?id=${e.userId}" );
        // data = data.replaceAll( "/${e3.userId}", "?id=${e3.userId}" );
        // data = data.replaceAll( gtm_id_codebase, window.gtm_id );
        // console.log('use gtmid: ', window.gtm_id);
        var add = document.createElement( "script" );
        add.innerText = data;
        document.body.appendChild( add );
    } );
}
LoadSymptomToolReactApp( );

